import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { ChevronRight } from "react-feather";
import styled, { ThemeContext } from "styled-components/macro";

import { getBreadcrumbs } from "../../store/sagas/selectors";

const BreadcrumbsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Breadcrumb = styled.div`
    display: flex;
    color: ${props => props.theme.textColor};
    justify-content: center;
    align-items: center;
    cursor: default;
`;

const ClickableBreadcrumb = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.textColor};
    transition: color 0.2s ease-in-out;
    @media (hover) {
        &:hover {
            text-decoration: underline;
            color: ${({ theme }) => theme.buttonNext.backgroundColor};
        }
    }
`;

const Breadcrumbs = ({ goBackSideMenu }: { goBackSideMenu: (event: any) => void }) => {
    const theme = useContext(ThemeContext);
    const breadcrumbs = useSelector(getBreadcrumbs);

    return (
        <BreadcrumbsContainer>
            {breadcrumbs.map((breadcrumb, index) => {
                return index < breadcrumbs.length - 1 ? (
                    <ClickableBreadcrumb key={breadcrumb.id} onClick={goBackSideMenu}>
                        <span>{breadcrumb.text}</span>
                        <ChevronRight size={20} color={theme.sideMenu.chevron.color} />
                    </ClickableBreadcrumb>
                ) : (
                    <Breadcrumb key={breadcrumb.id}>
                        <span>{breadcrumb.text}</span>
                    </Breadcrumb>
                );
            })}
        </BreadcrumbsContainer>
    );
};

export default Breadcrumbs;
